export default () => {
  document.querySelectorAll('[data-shoppable-image]').forEach((container) => {
    const event = new CustomEvent('shoppableImageWillLoad', { detail: container });
    document.dispatchEvent(event);

    const productHandle = container.getAttribute('data-shoppable-image');

    const button = document.createElement('div');
    button.className = 'ShoppableImage__Button ShoppableImage__Button--dark';
    button.setAttribute('data-product', productHandle);

    button.innerHTML = `
      <div class="circle circle--white">
        <i class="far fa-shopping-bag"></i>
      </div>
      Shop This
    `;

    container.appendChild(button);
  });
};
